import { Link } from 'react-router-dom';
import { getHotStories } from '@/lib/content';

const FEATURES = [
  {
    icon: 'ri-list-check-2',
    title: '先看要点',
    desc: '每条内容开头就是 3 到 4 条速览要点，不用读完全文也能掌握核心。',
  },
  {
    icon: 'ri-file-text-line',
    title: '再看摘要',
    desc: '精简摘要控制在 120 字以内，把事件背景、进展和影响一次说清楚。',
  },
  {
    icon: 'ri-history-line',
    title: '碎片可续读',
    desc: '被打断也没关系，摘要和正文分层结构，随时可以接着往下看。',
  },
];

export default function SummaryModeSection() {
  const story = getHotStories(1)[0];

  return (
    <section id="summary" className="w-full bg-secondary-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.24em] text-secondary-300">
              <span className="h-px w-6 bg-secondary-400" aria-hidden="true"></span>
              Summary mode
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[32px]">
              精简摘要模式：把长文变成三行能读完的结论
            </h2>
            <p className="mt-4 max-w-lg font-body text-sm leading-relaxed text-background-300 md:text-base">
              我们相信信息不该用长度来证明价值。5看料网把每一篇内容重新编排成"要点 + 摘要 + 正文"三层结构，你可以只读第一层，也可以一直读到最后。
            </p>

            <ul className="mt-8 flex flex-col gap-5">
              {FEATURES.map((feature) => (
                <li key={feature.title} className="flex items-start gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-800 text-secondary-100">
                    <i className={`${feature.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-semibold text-background-50">
                      {feature.title}
                    </span>
                    <span className="mt-1 block font-body text-sm leading-relaxed text-background-300">
                      {feature.desc}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-secondary-800 bg-background-50 p-5 md:p-6">
            <div className="flex items-center justify-between gap-3 border-b border-background-200 pb-4">
              <span className="flex items-center gap-2 font-label text-xs text-foreground-500">
                <i className="ri-eye-line text-base" aria-hidden="true"></i>
                速览预览
              </span>
              <span className="rounded-md bg-accent-100 px-2.5 py-1 font-label text-xs font-medium text-accent-900">
                {story.categoryName}
              </span>
            </div>

            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950">
              {story.title}
            </h3>

            <div className="mt-4 rounded-md bg-background-100 p-4">
              <span className="font-label text-xs font-medium uppercase tracking-[0.16em] text-secondary-600">
                精简摘要
              </span>
              <p className="mt-2 font-body text-sm leading-relaxed text-foreground-700">
                {story.summary}
              </p>
            </div>

            <div className="mt-4">
              <span className="font-label text-xs font-medium uppercase tracking-[0.16em] text-primary-600">
                速览要点
              </span>
              <ul className="mt-3 flex flex-col gap-2.5">
                {story.points.slice(0, 3).map((point) => (
                  <li key={point} className="flex items-start gap-2.5">
                    <i className="ri-checkbox-circle-fill mt-0.5 text-base text-primary-500" aria-hidden="true"></i>
                    <span className="font-body text-sm leading-relaxed text-foreground-700">{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Link
              to={`/article/${story.id}`}
              className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读完整速览
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}